import React, { ComponentProps, useState } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { AddFormElements } from '../../_lib/Form2';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { BasicPrivilegeConfigDefaultView } from './views/BasicPrivilegeConfigDefaultView';
import { BasicPrivilegeCreateEditModal } from './partials/BasicPrivilegeCreateEditModal';
import { ContentHeadline } from '../../_lib/components/ContentHeadline';

function BasicPrivilegeConfig(props: any) {
  const { t } = useSonTranslation('PrivilegeConfig');
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="privilege-config">
      <div className="privilege-config__headline">
        <ContentHeadline title={t('basicPrivileges')} hierarchy={2} modifier="top-headline" />
      </div>
      <div className="privilege-config__add-form-button">
        <AddFormElements name={t('addBasicPrivilege')} onClick={() => setShowModal(true)} />
      </div>
      <BasicPrivilegeConfigDefaultView {...props.views.default} />
      {showModal && (
        <BasicPrivilegeCreateEditModal
          form={props.views.default.embedded.createForm}
          closeModal={() => setShowModal(false)}
        />
      )}
    </div>
  );
}

export const BasicPrivilegeConfigBlock = asFetchableBlock(
  BasicPrivilegeConfig,
  BlockType.basicprivilegeconfig,
  BlockType.basicprivilegeconfig, // we register this block so it can be refreshed via the useInvalidate hook
);
export type BasicPrivilegeConfigBlock = ComponentProps<typeof BasicPrivilegeConfigBlock>;
